import {  Grid, Button, Menu, MenuItem } from '@mui/material';
import { HeaderMutualLogo } from './icons/Header';
import { useCustomContext } from './AuthContext';
import React, { useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Navbar from './Navbar'
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import firebase from 'firebase/compat/app';


const Header = () => {
    const context = useCustomContext()
    const [openNavbar, setOpenNavbar] = useState(false)

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };

    //This function needs to be moved to a different layer
    const handleLogout = async () => { 
        firebase.auth().signOut()
    }
        if(context.width < 786){

            if(openNavbar){

                return(
                    <Grid className='open-mobile-navbar' onClick={() => setOpenNavbar(false)}>
                        <CloseIcon className='close-mobile-navbar'/>
                        <ul>
                            <li>
                                Mutual
                                <ul className='embedded-links'>
                                    <li><a href="/premium/">MutualUp</a> </li>
                                    <li><a href='https://mutual.app/standards'>Community Standards</a></li>
                                    <li><a href='https://mutual.app/terms'>Mutual Terms of Service</a></li>
                                    <li><a href='https://mutual.app/privacy'>Mutual Privacy Policy</a></li>
                                </ul>
                            </li>
                            <li>MutualDates
                                <ul className='embedded-links'>
                                        <li><a href='https://mutual.app/datesterms'>MutualDates Terms of Sale</a></li>
                                        <li><a href='https://mutual.app/datespartnerterms'>MutualDates Partner Terms of Use</a></li>
                                </ul>
                            </li>
                            <li><a href='https://support.mutual.app/'>Support</a></li>
                            <li><a href='https://mutual.app/careers'>Careers</a></li>
                            <li><a href='https://blog.mutual.app/'>Blog</a></li>
                        </ul>
                    </Grid>
                )
            }
            else{
                return (
                    <Grid 
                        container 
                        justifyContent='center'
                        className='header-wrapper-mobile'
                    >
                        <HeaderMutualLogo/>
                        <MenuIcon className='header-mobile-icon' onClick={() => setOpenNavbar(true)}/>
                    </Grid>
                )
            }

    
        }
        else{
            return ( 
                <Grid container justifyContent="center" style={{padding: '1px 20px', backgroundColor: '#fff'}}>
                    <Grid container className="header-top" justifyContent="center" flexDirection="column">
                        <Grid container flexDirection="row" alignContent="baseline">
                            <Grid container alignContent="baseline" item className="mutual-logo-image" justifyContent="space-between" flexWrap="nowrap">

                                <Grid style={{alignSelf: 'center'}} >
                                    <HeaderMutualLogo/>
                                </Grid>

                                <Grid 
                                    container 
                                    style={{width: '80%'}} 
                                    flexDirection="row" 
                                    alignContent="center" 
                                    justifyContent="space-between"
                                    flexWrap="wrap"
                                >
                                    
                                    <Navbar/>
                                    
                                    <Grid style={{alignSelf: "center"}}>
                                        {
                                            !context.isLogged 
                                            ?
                                            //This is to send to the /login page (external page) 
                                            null
                                            : 
                                            //This is a drop-down button to send to the account management or logout the user
                                            <div>
                                                <Button
                                                    aria-expanded={open ? 'true' : undefined}
                                                    onClick={handleClick}
                                                    endIcon={open ? <KeyboardArrowDownIcon/> : <KeyboardArrowUpIcon/>}
                                                    style={{padding: '0px !important'}}
                                                >
                                                    <span style={{textTransform: 'none'}}>{context.user.firstName} {context.user.lastName}</span>
                                                </Button>
                                                <Menu
                                                    anchorEl={anchorEl}
                                                    open={open}
                                                    onClose={handleClose}
                                                    style={{padding: '0px !important'}}
                                                >
                                                    <MenuItem onClick={handleClose}>Manage Profile</MenuItem>
                                                    <MenuItem onClick={handleLogout}>Logout</MenuItem>
                                                </Menu>
                                            </div>
                                        }
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            )
        }
}

export default Header;






